// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/set_dressing_reference.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/set_dressing_reference.proto.
 */
export const file_vision_assets_v1_set_dressing_reference: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vYXNzZXRzL3YxL3NldF9kcmVzc2luZ19yZWZlcmVuY2UucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIrkBChRTZXREcmVzc2luZ1JlZmVyZW5jZRIQCghhc3NldF9pZBgBIAEoCRISCgpwcm9qZWN0X2lkGAIgASgJEh4KFnVwbG9hZGVkX2J5X2FjY291bnRfaWQYAyABKAkSFAoMb3JpZ2luYWxfdXJsGAQgASgJEhUKDXRodW1ibmFpbF91cmwYBSABKAkSLgoKY3JlYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.assets.v1.SetDressingReference
 */
export type SetDressingReference = Message<"protos.vision.assets.v1.SetDressingReference"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string uploaded_by_account_id = 3;
   */
  uploadedByAccountId: string;

  /**
   * @generated from field: string original_url = 4;
   */
  originalUrl: string;

  /**
   * @generated from field: string thumbnail_url = 5;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetDressingReference.
 * Use `create(SetDressingReferenceSchema)` to create a new message.
 */
export const SetDressingReferenceSchema: GenMessage<SetDressingReference> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_dressing_reference, 0);

